/**
 * Generates a unique group ID for tracking related events in an interaction.
 * @param prefix - A string prefix to identify the interaction type (e.g., "create-lock", "approve-token")
 * @returns A unique group ID string in the format: `{prefix}-{timestamp}-{random}`
 */
export const makeGroupId = (prefix: string): string => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
}
